import styled from "styled-components";
import { getHexOpacity } from "../../../utils/pipes";

export const ContentManagement = styled.div`
  background-color: #e3e4ee;
  height: 100%;
  .content-management-toolbar {
    padding: 37px 76px;
    .label {
      font-family: Nunito Sans;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .toolbar-container {
      
    }
  }
  .content-management-list {
    margin: 0 76px;
    height: calc(100% - 159px);
    overflow-y: auto;
  }
`;